import { LockOutlined } from '@ant-design/icons';
import { Button, Col, Form, Input, Row, Spin, Typography } from 'antd';
import type { Rule } from 'rc-field-form/lib/interface';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { getMessage } from '../../common/compornents/GetMessageUtil';
import Header from '../../common/compornents/layout/header/Header';
import { notificationError, notificationSuccess } from '../../common/compornents/notification';
import { Const } from '../../common/constants/Constants';
import { Message } from '../../common/constants/Message';
import { generateMessage } from '../../common/util/MessageUtil';
import Logo from '../../kikusuiロゴ2.png';
import LoginServ from '../../services/LoginServ';

const { Title } = Typography;

/**
 * ログイン画面
 *
 * @returns
 */

//レイアウト
const formItemLayout = {
  labelCol: {
    sm: { span: 19 },
    md: { span: 18 },
    lg: { span: 17 },
    xl: { span: 14 },
    xxl: { span: 11 },
  },
};

const formItemLayoutMailAdd = {
  labelCol: {
    sm: { span: 18 },
    md: { span: 17 },
    lg: { span: 16 },
    xl: { span: 12 },
    xxl: { span: 9 },
  },
};

const Login: React.FC = () => {
  // Input句の必須チェック設定
  const ruleRequired = { required: true, message: '必須項目が入力されていません' };

  // 画面項目の保持
  const [companyCd, setCompanyCd] = useState('');
  const [accountId, setAccountId] = useState('');
  const [password, setPassword] = useState('');
  const [name, setName] = useState('');
  const [changedPass, setChangedPass] = useState('');
  const [changedPassConf, setChangedPassConf] = useState('');
  const [mailAdd, setMailAdd] = useState('');

  // パスワード変更部分
  const [showFlag, setShowFlag] = useState(false);

  // パスワードリセット部分
  const [showResetFlag, setShowResetFlag] = useState(false);

  // パスワード必須チェック
  const [ruleInputPass, setRuleInputPass] = useState<Rule[]>([ruleRequired]);

  // ご担当者必須チェック
  const [ruleInputTanName, setRuleInputTanName] = useState<Rule[]>([ruleRequired]);

  // 変更パスワード必須チェック
  const [ruleInputChangePass, setRuleInputChangePass] = useState<Rule[]>([]);

  // 変更確認パスワード必須チェック
  const [ruleInputConfiPass, setRuleInputConfiPas] = useState<Rule[]>([]);

  // メールアドレス必須チェック
  const [ruleInputMailAdd, setRuleInputMailAdd] = useState<Rule[]>([]);

  // 活性非活性
  const [disable, setDisable] = useState(false);

  // インジケーター表示フラグ
  const [loading, changeLoading] = useState<boolean>(false);

  // const storedJwt = localStorage.getItem('token');
  // const [jwt, setJwt] = useState(storedJwt || null);

  // フォームの定義（入力チェックで使用）
  const [form] = Form.useForm();
  const history = useHistory();

  /**
   *  各入力値をstateに保持
   */
  const cpnyCdBlur = (e: any) => {
    setCompanyCd(() => e.target.value);
  };
  const acntIdBlur = (e: any) => {
    setAccountId(() => e.target.value);
  };
  const passBlur = (e: any) => {
    setPassword(() => e.target.value);
  };
  const nameBlur = (e: any) => {
    setName(() => e.target.value);
  };
  const changedPassBlur = (e: any) => {
    setChangedPass(() => e.target.value);
  };
  const confBlur = (e: any) => {
    setChangedPassConf(() => e.target.value);
  };
  const mailAddressBlur = (e: any) => {
    setMailAdd(() => e.target.value);
  };

  /**
   * 初期処理
   */
  useEffect(() => {
    // セッションストレージをクリア
    sessionStorage.clear();
  }, []);

  /**
   * パスワード変更ボタン押下イベント
   */
  const onChangePassClick = () => {
    if (!showFlag) {
      // 表示非表示設定
      setShowFlag(true);
      setShowResetFlag(false);
      // 必須設定
      setRuleInputChangePass([ruleRequired]);
      setRuleInputConfiPas([ruleRequired]);
      setRuleInputPass([ruleRequired]);
      // 非必須設定
      setRuleInputTanName([]);
      setRuleInputMailAdd([]);
      setName('');
      setMailAdd('');
      // ログインボタン非活性
      setDisable(true);
    } else {
      // 非表示設定
      setShowFlag(false);
      // 必須設定
      setRuleInputPass([ruleRequired]);
      setRuleInputTanName([ruleRequired]);
      // 非必須設定
      setRuleInputChangePass([]);
      setRuleInputConfiPas([]);
      setChangedPass('');
      setChangedPassConf('');
      // ログインボタン活性
      setDisable(false);
    }
  };

  /**
   * パスワードリセットボタン（パスワードを忘れたときはこちら）押下イベント
   */
  const onResetPassClick = () => {
    if (!showResetFlag) {
      // 表示非表示
      setShowResetFlag(true);
      setShowFlag(false);
      // 必須設定
      setRuleInputMailAdd([ruleRequired]);
      // 非必須設定
      setRuleInputPass([]);
      setRuleInputTanName([]);
      setRuleInputChangePass([]);
      setRuleInputConfiPas([]);
      setPassword('');
      setName('');
      setChangedPass('');
      setChangedPassConf('');
      // ログインボタン非活性
      setDisable(true);
    } else {
      // 非表示設定
      setShowResetFlag(false);
      // 必須設定
      setRuleInputPass([ruleRequired]);
      setRuleInputTanName([ruleRequired]);
      // 非必須設定
      setRuleInputMailAdd([]);
      setMailAdd('');
      // ログインボタン活性
      setDisable(false);
    }
  };

  /**
   * Null のときに指定文字に置き換える
   */
  const nvl = (value1: any, value2: string) => {
    return value1 == null ? value2 : value1;
  };

  /**
   * アカウント情報取得および画面遷移
   */
  const getAccountInfo = async () => {
    // APIとの同期処理
    // アカウント情報取得APIを呼び出し
    await LoginServ.clickLogin(companyCd, accountId, password)
      .then((json) => {
        console.log(json);

        // ローカルストレージにデータを保存
        sessionStorage.setItem(Const.LOCAL_STORAGE_VALUE.COMPANY_CD, companyCd);
        sessionStorage.setItem(
          Const.LOCAL_STORAGE_VALUE.COMPANY_NAME,
          nvl(json.data['compny_nm'], '')
        );
        sessionStorage.setItem(Const.LOCAL_STORAGE_VALUE.ACCOUNT_ID, accountId);
        sessionStorage.setItem(Const.LOCAL_STORAGE_VALUE.TANTO_NAME, name);
        sessionStorage.setItem(Const.LOCAL_STORAGE_VALUE.KYOTEN_CD, nvl(json.data['ktn_cd'], ''));
        sessionStorage.setItem(
          Const.LOCAL_STORAGE_VALUE.JISHA_KBN,
          nvl(json.data['jisya_kbn'], '')
        );
        sessionStorage.setItem(Const.LOCAL_STORAGE_VALUE.JWT, nvl(json.data['jwt'], ''));
        if (json.data['jisya_kbn'] !== '1') {
          sessionStorage.setItem(
            Const.LOCAL_STORAGE_VALUE.TOKUISAKI_CD,
            nvl(json.data['tok_cd'], '')
          );
          sessionStorage.setItem(
            Const.LOCAL_STORAGE_VALUE.TOKUISAKI_CD2,
            nvl(json.data['tok_cd2'], '')
          );
        }

        console.log(json.data['jwt']);
        return json;
      })
      .then((json) => {
        // 結果コードチェック
        if (json.data['rsltCd'] === Const.RESULT_CODE.SUCCESS) {
          // 画面遷移
          transition(json.data['jisya_kbn']);
        } else {
          // エラーの場合メッセージを出力
          let msg: string = getMessage(json.data['rsltCd'], 'ログイン');
          notificationError('ログイン', msg);
        }
      });
  };

  /**
   * 画面遷移
   *
   * @param jishaKbn 自社区分
   */
  const transition = (jishaKbn: String) => {
    var transitionUrl: String;
    if (jishaKbn === '1') {
      // 受注照会画面へ遷移
      transitionUrl = '/juchuShokai/1';
    } else {
      // 注文入力画面へ遷移
      transitionUrl = '/juchu-nyuryoku';
    }
    //alert(sessionStorage.getItem("jwt"));

    history.push(String(transitionUrl));
  };

  /**
   * パスワード更新
   */
  const updatePass = async () => {
    // APIとの同期処理
    // パスワード更新APIを呼び出し
    await LoginServ.clickUpdate(companyCd, accountId, password, changedPass, changedPassConf).then(
      (json) => {
        console.log(json);
        // 結果コードチェック
        if (json.data === Const.RESULT_CODE.SUCCESS) {
          notificationSuccess('パスワード更新', '');
          // 画面リセット
          resetDisp();
        } else {
          // エラーの場合メッセージを出力
          let msg: string = getMessage(json.data, 'パスワード更新');
          notificationError('パスワード更新', msg);
        }
      }
    );
  };

  /**
   * パスワードリセット
   */
  const resetPass = async () => {
    // APIとの同期処理W
    // パスワードリセットAPIを呼び出し
    await LoginServ.clickSend(companyCd, accountId, mailAdd).then((json) => {
      console.log(json);
      // 結果コードチェック
      if (json.data === Const.RESULT_CODE.SUCCESS) {
        notificationSuccess(
          'パスワードリセット',
          '初期パスワードが記載されたメールが送信されました。ご確認ください'
        );
        // 画面リセット
        resetDisp();
      } else {
        // エラーの場合メッセージを出力
        let msg: string = getMessage(json.data, 'パスワードリセット');
        notificationError('パスワードリセット', msg);
      }
    });
  };

  /**
   * ログインボタン押下
   */
  const handleLogin = () => {
    if (loading) return;
    changeLoading(true);
    form.validateFields().then(async () => {
      console.log({ companyCd });
      console.log({ accountId });
      console.log({ password });
      console.log({ name });

      await getAccountInfo();
    });
    changeLoading(false);
  };

  /**
   * 更新ボタン押下
   */
  const handleUpdate = async () => {
    if (loading) return;
    changeLoading(true);
    form.validateFields().then(async () => {
      console.log({ companyCd });
      console.log({ accountId });
      console.log({ password });
      console.log({ changedPass });
      console.log({ changedPassConf });

      await updatePass();
    });
    changeLoading(false);
  };

  /**
   * 送信ボタン押下
   */
  const handleSend = async () => {
    if (loading) return;
    changeLoading(true);
    form.validateFields().then(async () => {
      console.log({ companyCd });
      console.log({ accountId });
      console.log({ mailAdd });

      await resetPass();
    });
    changeLoading(false);
  };

  /**
   * 画面リセット
   */
  const resetDisp = () => {
    form.resetFields();
    setCompanyCd('');
    setAccountId('');
    setPassword('');
    setName('');
    setChangedPass('');
    setChangedPassConf('');
    setMailAdd('');
    setShowFlag(false);
    setShowResetFlag(false);
    setRuleInputPass([ruleRequired]);
    setRuleInputTanName([ruleRequired]);
    setRuleInputChangePass([]);
    setRuleInputConfiPas([]);
    setRuleInputMailAdd([]);
    setDisable(false);
  };

  return (
    <div style={{ backgroundColor: '#e6f7ff', minHeight: '100vh' }}>
      <Spin spinning={loading}>
        <Header screenName={'ログイン'} />
        <Form form={form} layout="horizontal" autoComplete="off" initialValues={{ remember: true }}>
          <Row>
            <Col
              xs={{ span: 24, offset: 1 }}
              sm={{ span: 22, offset: 2 }}
              md={{ span: 20, offset: 4 }}
              lg={{ span: 13, offset: 8 }}
              xl={{ span: 12, offset: 9 }}
              xxl={{ span: 10, offset: 9 }}
            >
              <Title style={{ paddingTop: '10px' }}>
                <img
                  alt="ロゴ"
                  src={Logo}
                  style={{
                    height: '50px',
                    marginBottom: '10px',
                    width: 'auto',
                  }}
                />{' '}
                WEB受注システム
              </Title>
            </Col>
          </Row>

          {/* カンパニーコード */}
          <Row style={{ paddingTop: '3vh' }}>
            <Col
              xs={{ span: 8, offset: 7 }}
              sm={{ span: 15, offset: 1 }}
              lg={{ span: 12, offset: 3 }}
              xl={{ span: 6, offset: 8 }}
              xxl={{ span: 4, offset: 9 }}
            >
              <Form.Item
                {...formItemLayout}
                label="カンパニーCD"
                name="companyCd"
                rules={[
                  {
                    required: true,
                    message: generateMessage(Message.ERROR_MASSAGE.ERR001, 'カンパニーCD'),
                  },
                  {
                    pattern: /^[a-zA-Z0-9]+$/,
                    message: generateMessage(Message.ERROR_MASSAGE.ERR017, 'カンパニーCD'),
                  },
                ]}
              >
                <Input maxLength={10} onBlur={cpnyCdBlur} />
              </Form.Item>
            </Col>
          </Row>

          {/* アカウントID */}
          <Row>
            <Col
              xs={{ span: 8, offset: 7 }}
              sm={{ span: 15, offset: 1 }}
              lg={{ span: 12, offset: 3 }}
              xl={{ span: 6, offset: 8 }}
              xxl={{ span: 4, offset: 9 }}
            >
              <Form.Item
                {...formItemLayout}
                label="アカウントID"
                name="accountId"
                rules={[
                  {
                    required: true,
                    message: generateMessage(Message.ERROR_MASSAGE.ERR001, 'アカウントID'),
                  },
                  {
                    pattern: /^[a-zA-Z0-9]+$/,
                    message: generateMessage(Message.ERROR_MASSAGE.ERR017, 'アカウントID'),
                  },
                ]}
              >
                <Input maxLength={10} onBlur={acntIdBlur} />
              </Form.Item>
            </Col>
          </Row>

          {/* パスワード */}
          <Row>
            <Col
              xs={{ span: 8, offset: 7 }}
              sm={{ span: 15, offset: 1 }}
              lg={{ span: 12, offset: 3 }}
              xl={{ span: 6, offset: 8 }}
              xxl={{ span: 4, offset: 9 }}
            >
              <Form.Item
                {...formItemLayout}
                label="パスワード"
                name="password"
                rules={ruleInputPass}
              >
                <Input.Password
                  // minLength={12}
                  prefix={<LockOutlined />}
                  type="password"
                  onBlur={passBlur}
                />
              </Form.Item>
            </Col>
          </Row>

          {/* ご担当者 */}
          <Row>
            <Col
              xs={{ span: 8, offset: 7 }}
              sm={{ span: 15, offset: 1 }}
              lg={{ span: 12, offset: 3 }}
              xl={{ span: 6, offset: 8 }}
              xxl={{ span: 4, offset: 9 }}
            >
              <Form.Item
                {...formItemLayout}
                label="ご担当者"
                name="manager"
                rules={ruleInputTanName}
              >
                <Input maxLength={10} type="text" onBlur={nameBlur} />
              </Form.Item>
            </Col>
          </Row>

          {/* ログインボタン */}
          <Row justify="end">
            <Col sm={6} lg={7} xl={8} xxl={9}>
              <Form.Item>
                <Button type="primary" size={'large'} onClick={handleLogin} disabled={disable}>
                  ログイン
                </Button>
              </Form.Item>
            </Col>
          </Row>

          {/* 表示切替 */}
          <Row>
            {/* パスワード変更 */}
            <Col xs={{ offset: 6 }} sm={{ offset: 5 }} md={{ offset: 8 }} lg={{ offset: 9 }}>
              <Button type="link" onClick={onChangePassClick} size={'large'}>
                パスワード変更
              </Button>
            </Col>
            {/* パスワードリセット */}
            <Col
              xs={{ offset: 6 }}
              sm={{ offset: 3 }}
              md={{ offset: 3 }}
              lg={{ offset: 4 }}
              xl={{ offset: 3 }}
              xxl={{ offset: 4 }}
            >
              <Button type="link" onClick={onResetPassClick} size={'large'}>
                パスワードを忘れた時はこちら
              </Button>
            </Col>
          </Row>

          {/* パスワード変更部分 */}
          {/* 変更パスワード */}
          <Row
            style={{
              display: showFlag ? '' : 'none',
              paddingTop: '2vh',
            }}
          >
            <Col
              xs={{ span: 8, offset: 7 }}
              sm={{ span: 15, offset: 1 }}
              lg={{ span: 12, offset: 3 }}
              xl={{ span: 6, offset: 8 }}
              xxl={{ span: 4, offset: 9 }}
            >
              <Form.Item
                {...formItemLayout}
                label="変更パスワード"
                name={'pass'}
                rules={ruleInputChangePass}
              >
                <Input.Password minLength={12} type="text" onBlur={changedPassBlur} />
              </Form.Item>
            </Col>
            <Col
              xs={{ offset: 2 }}
              sm={{ offset: 5 }}
              md={{ offset: 8 }}
              xl={{ offset: 1 }}
              xxl={{ offset: 2 }}
            >
              <Form.Item>
                <span style={{ color: '#f5222d' }}>
                  *パスワードは大文字小文字英数字混在の12桁以上で入力してください
                </span>
              </Form.Item>
            </Col>
          </Row>

          {/* 確認用 */}
          <Row
            style={{
              display: showFlag ? '' : 'none',
            }}
          >
            <Col
              xs={{ span: 8, offset: 7 }}
              sm={{ span: 15, offset: 1 }}
              lg={{ span: 12, offset: 3 }}
              xl={{ span: 6, offset: 8 }}
              xxl={{ span: 4, offset: 9 }}
            >
              <Form.Item
                {...formItemLayout}
                label="確認用"
                name={'confi'}
                rules={ruleInputConfiPass}
              >
                <Input.Password minLength={12} type="text" onBlur={confBlur} />
              </Form.Item>
            </Col>
          </Row>
          <Row
            justify="end"
            style={{
              display: showFlag ? '' : 'none',
            }}
          >
            <Col sm={6} lg={7} xl={8} xxl={9}>
              <Button type="primary" size={'large'} onClick={handleUpdate}>
                更新
              </Button>
            </Col>
          </Row>

          {/* パスワードリセット部分 */}
          {/* メールアドレス */}
          <Row
            style={{
              display: showResetFlag ? '' : 'none',
              paddingTop: '2vh',
            }}
          >
            <Col
              xs={{ span: 10, offset: 7 }}
              sm={{ span: 16, offset: 1 }}
              lg={{ span: 13, offset: 3 }}
              xl={{ span: 7, offset: 8 }}
              xxl={{ span: 5, offset: 9 }}
            >
              <Form.Item
                {...formItemLayoutMailAdd}
                label="メールアドレス"
                name={'mailAddress'}
                rules={ruleInputMailAdd}
              >
                <Input maxLength={50} type="text" onBlur={mailAddressBlur} />
              </Form.Item>
            </Col>
          </Row>
          <Row
            justify="end"
            style={{
              display: showResetFlag ? '' : 'none',
            }}
          >
            <Col sm={6} lg={7} xl={8} xxl={9}>
              <Button type="primary" size={'large'} onClick={handleSend}>
                送信
              </Button>
            </Col>
          </Row>
        </Form>
      </Spin>
    </div>
  );
};

export default Login;
